// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.article-temp-wrapper-data {
  padding: 0 16px 0px 16px;
  display: block;
  width: 100%;
}
.article-temp-wrapper-data .show-more-btn {
  padding: 8px 0;
  color: var(--sdk-global-theme-color);
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  border: 0;
  background: transparent;
  cursor: pointer;
}

.articles-block {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
}
.articles-block .article-card {
  border-radius: 4px;
  border: 1px solid var(--sdk-gloabl-border-color);
  background: var(--sdk-global-white-bg);
  display: flex;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  transition: 0.2s all ease;
  text-align: start;
  cursor: pointer;
}
.articles-block .article-card:hover {
  background: var(--sdk-gloabl-bg-secondary);
}
.articles-block .article-card .article-header {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
}
.articles-block .article-card .article-header svg {
  flex-shrink: 0;
}
.articles-block .article-card .article-header svg path {
  fill: var(--sdk-gloabl-text-color);
}
.articles-block .article-card .article-header span {
  width: 100%;
  color: var(--sdk-gloabl-text-color);
  font-size: 14px;
  font-weight: 600;
}
.articles-block .article-card .article-body-text {
  width: 100%;
  color: var(--sdk-gloabl-text-color);
  font-size: 12px;
  font-weight: 400;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 16px;
}
.articles-block .article-card .article-footer {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
}
.articles-block .article-card .article-footer div {
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: var(--sdk-gloabl-text-color);
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
}

.article-full-card-content-details {
  flex: 1 1 auto;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.article-full-card-content-details .scroll-inner-data {
  overflow: auto;
  flex: 1 1 auto;
  padding: 0 16px 10px 16px;
}
.article-full-card-content-details .scroll-inner-data p {
  color: var(--sdk-gloabl-text-color);
  margin: 0;
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
}
.article-full-card-content-details .article-update-time-block {
  border-radius: 8px;
  background: var(--sdk-gloabl-bg-secondary);
  display: flex;
  padding: 8px 16px;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  margin: 16px 16px 0 16px;
  word-break: break-word;
}
.article-full-card-content-details .article-update-time-block .created-updated-text {
  color: var(--sdk-gloabl-text-color);
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
  width: 100%;
}
.article-full-card-content-details .article-update-time-block a {
  display: flex;
  align-items: center;
  gap: 8px;
  border: 0;
  padding: 0;
  background: transparent;
  color: var(--sdk-global-theme-color);
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  flex-shrink: 0;
  text-decoration: none;
  cursor: pointer;
}
.article-full-card-content-details .article-update-time-block a svg path {
  fill: var(--sdk-global-theme-color);
}`, "",{"version":3,"sources":["webpack://./src/templatemanager/templates/articleTemplate/article.scss"],"names":[],"mappings":"AACA;EACI,wBAAA;EACA,cAAA;EACA,WAAA;AAAJ;AACI;EACI,cAAA;EACA,oCAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;AACR;;AAGA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,QAAA;AAAJ;AACI;EACI,kBAAA;EACA,gDAAA;EACA,sCAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,QAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;AACR;AAAQ;EACI,0CAAA;AAEZ;AAAQ;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;AAEZ;AADY;EACI,cAAA;AAGhB;AAFgB;EACI,kCAAA;AAIpB;AADY;EACI,WAAA;EACA,mCAAA;EACA,eAAA;EACA,gBAAA;AAGhB;AAAQ;EACI,WAAA;EACA,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,iBAAA;AAEZ;AAAQ;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAEZ;AADY;EACI,OAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAGhB;;AAGA;EACI,cAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAAJ;AACI;EACI,cAAA;EACA,cAAA;EACA,yBAAA;AACR;AAAQ;EACI,mCAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAEZ;AACI;EACI,kBAAA;EACA,0CAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,wBAAA;EACA,sBAAA;AACR;AAAQ;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AAEZ;AAAQ;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;EACA,oCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;AAEZ;AAAgB;EACI,mCAAA;AAEpB","sourcesContent":["\n.article-temp-wrapper-data{\n    padding: 0 16px 0px 16px;\n    display: block;\n    width: 100%;\n    .show-more-btn{\n        padding: 8px 0;\n        color: var(--sdk-global-theme-color);\n        text-align: center;\n        font-size: 12px;\n        font-weight: 500;\n        line-height: 18px;\n        border: 0;\n        background: transparent;\n        cursor: pointer;\n    }\n}\n\n.articles-block{\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    gap: 8px;\n    .article-card{\n        border-radius: 4px;\n        border: 1px solid var(--sdk-gloabl-border-color);\n        background: var(--sdk-global-white-bg);\n        display: flex;\n        padding: 16px;\n        flex-direction: column;\n        justify-content: center;\n        align-items: flex-start;\n        gap: 4px;\n        transition: 0.2s all ease;\n        text-align: start;\n        cursor: pointer;\n        &:hover{\n            background: var(--sdk-gloabl-bg-secondary); \n        }\n        .article-header{\n            display: flex;\n            align-items: center;\n            gap: 4px;\n            width: 100%;\n            svg{\n                flex-shrink: 0;\n                path{\n                    fill: var(--sdk-gloabl-text-color);\n                }\n            }\n            span{\n                width: 100%;\n                color: var(--sdk-gloabl-text-color);\n                font-size: 14px;\n                font-weight: 600;\n            }\n        }\n        .article-body-text{\n            width: 100%;\n            color: var(--sdk-gloabl-text-color);\n            font-size: 12px;\n            font-weight: 400;\n            display: -webkit-box;\n            -webkit-line-clamp: 3;\n            -webkit-box-orient: vertical;\n            overflow: hidden;\n            line-height: 16px;\n        }\n        .article-footer{\n            width: 100%;\n            display: flex;\n            align-items: center;\n            gap: 6px;\n            margin-top: 6px;\n            div{\n                flex: 1;\n                overflow: hidden;\n                white-space: nowrap;\n                text-overflow: ellipsis;\n                color: var(--sdk-gloabl-text-color);\n                font-size: 12px;\n                font-weight: 400;\n                line-height: normal;\n            }\n        }\n    }\n}\n\n.article-full-card-content-details{\n    flex: 1 1 auto;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    .scroll-inner-data{\n        overflow: auto;\n        flex: 1 1 auto;\n        padding: 0 16px 10px 16px;\n        p{\n            color: var(--sdk-gloabl-text-color);\n            margin: 0;\n            font-size: 12px;\n            font-weight: 400;\n            line-height: normal;\n        }\n    }\n    .article-update-time-block{\n        border-radius: 8px;\n        background: var(--sdk-gloabl-bg-secondary);\n        display: flex;\n        padding: 8px 16px;\n        align-items: center;\n        gap: 16px;\n        align-self: stretch;\n        margin: 16px 16px 0 16px;\n        word-break: break-word;\n        .created-updated-text{\n            color: var(--sdk-gloabl-text-color);\n            font-size: 12px;\n            font-weight: 400;\n            line-height: normal;\n            width: 100%;\n        }\n        a{\n            display: flex;\n            align-items: center;\n            gap: 8px;\n            border: 0;\n            padding: 0;\n            background: transparent;\n            color: var(--sdk-global-theme-color);\n            font-size: 14px;\n            font-weight: 500;\n            line-height: 20px;\n            flex-shrink: 0;\n            text-decoration: none;\n            cursor: pointer;\n            svg{\n                path{\n                    fill: var(--sdk-global-theme-color);\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
